"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRecaptchaGoogle = require("react-recaptcha-google");
var _global = _interopRequireDefault(require("global"));
var _TywGroupBookings = _interopRequireDefault(require("./templates/tyw/TywGroupBookings"));
var _TywContactUs = _interopRequireDefault(require("./templates/tyw/TywContactUs"));
var _TswContactUs = _interopRequireDefault(require("./templates/tsw/TswContactUs"));
var _YnfContactUs = _interopRequireDefault(require("./templates/ynf/YnfContactUs"));
var _D8ContactUs = _interopRequireDefault(require("./templates/d8/D8ContactUs"));
var _QDContactUs = _interopRequireDefault(require("./templates/qd/QDContactUs"));
var _TywBookACall = _interopRequireDefault(require("./templates/tyw/TywBookACall"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var templates = {
  tyw_group_bookings: _TywGroupBookings["default"],
  tyw_contact_us: _TywContactUs["default"],
  tyw_book_a_call: _TywBookACall["default"],
  tsw_contact_us: _TswContactUs["default"],
  ynf_contact_us: _YnfContactUs["default"],
  d8_contact_us: _D8ContactUs["default"],
  qd_contact_us: _QDContactUs["default"]
};
var FlexForm = function FlexForm(_ref) {
  var template = _ref.template;
  (0, _react.useEffect)(function () {
    if (typeof _global["default"].grecaptcha === 'undefined') {
      (0, _reactRecaptchaGoogle.loadReCaptcha)();
    }
  }, []);
  var FormTemplate = template && templates[template];
  if (!FormTemplate) return null;
  return /*#__PURE__*/_react["default"].createElement(FormTemplate, null);
};
FlexForm.propTypes = {
  template: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = FlexForm;